<template>
    <div class="o-row u-spacer--2">
        <div class="o-extra-small--12">
            <p class="o-text--caption u-text--center u-text--gray">
                <slot></slot>
            </p>
        </div>
    </div>
</template>

<script setup>
</script>

<style lang="scss">
</style>
